"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACFixedRowInputTable = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/react-in-jsx-scope */
var antd_1 = require("antd");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var react_toastify_1 = require("react-toastify");
var sampleSlice_1 = require("../redux/slice/sampleSlice");
var utils_1 = require("../utils");
var helpers_1 = require("../utils/helpers");
var ACCircularInput_1 = require("./ACCircularInput");
var ACRadioGroup_1 = require("./ACRadioGroup");
var ACSlider_1 = require("./ACSlider");
var ACWrapperContext_1 = require("./ACWrapperContext");
var ACFixedRowInputTable = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var fieldName = props.name, _g = props.disabled, disabled = _g === void 0 ? false : _g, _h = props.color, color = _h === void 0 ? 'primary' : _h, _j = props.thead, thead = _j === void 0 ? [] : _j, _k = props.labelsEndpoint, labelsEndpoint = _k === void 0 ? '' : _k, _l = props.handlers, handlers = _l === void 0 ? [] : _l, rootState = props.rootState, context = props.context;
    var _m = (0, react_2.useState)(Boolean(labelsEndpoint)), loading = _m[0], setLoading = _m[1];
    var memoizedPropLabels = (0, react_2.useMemo)(function () { return props.labels; }, [props.labels]);
    var _o = (0, react_2.useState)([]), labels = _o[0], setLabels = _o[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var _p = (0, react_2.useState)([]), rows = _p[0], setRows = _p[1];
    var _q = (0, react_2.useState)({
        row: {},
        value: {},
        field: '',
    }), selectedCell = _q[0], setSelectedCell = _q[1];
    (0, react_2.useEffect)(function () {
        if (labelsEndpoint) {
            API_GET_Labels();
        }
    }, [labelsEndpoint]);
    var API_GET_Labels = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, labelsEndpoint, rootState, _b, functionName, params, endpoint, ParentUtils, func, res, data, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    _a = props.labelsEndpoint, labelsEndpoint = _a === void 0 ? '' : _a, rootState = props.rootState, _b = props.function, functionName = _b === void 0 ? '' : _b;
                    params = (props === null || props === void 0 ? void 0 : props.params) || {};
                    return [4 /*yield*/, utils_1.Utils.getProcessedEndpoint({
                            params: params,
                            endPoint: labelsEndpoint,
                            rootState: rootState,
                        })];
                case 1:
                    endpoint = _c.sent();
                    ParentUtils = (0, ACWrapperContext_1.getUtils)();
                    func = ParentUtils[functionName] || ParentUtils.makeApiCall;
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, 5, 6]);
                    return [4 /*yield*/, func("".concat(endpoint), 'GET')];
                case 3:
                    res = _c.sent();
                    if (!res.status) {
                        react_toastify_1.toast.error(res.message, {
                            position: 'top-center',
                            autoClose: 2000,
                        });
                        return [2 /*return*/];
                    }
                    data = res.data
                        .filter(function (e) { return e === null || e === void 0 ? void 0 : e.value; })
                        .map(function (option) { return (__assign(__assign({}, option), { label: option === null || option === void 0 ? void 0 : option.label, value: option === null || option === void 0 ? void 0 : option.value })); });
                    setLabels(__spreadArray([], data, true));
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _c.sent();
                    react_toastify_1.toast.error('Error', {
                        position: 'top-center',
                        autoClose: 2000,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    function createEmptyRow(id, label) {
        return thead.reduce(function (acc, curr) {
            if ((curr === null || curr === void 0 ? void 0 : curr.type) === 'fixed') {
                acc[curr === null || curr === void 0 ? void 0 : curr.name] = label.label;
            }
            else {
                acc[curr.name] = null;
            }
            return acc;
        }, { row_id: id, row_name: label.value });
    }
    var name = ((_a = props === null || props === void 0 ? void 0 : props.tbody) === null || _a === void 0 ? void 0 : _a.storedLocation) ||
        ((_c = (_b = handlers.find(function (e) { return (e === null || e === void 0 ? void 0 : e.action) === 'changeState'; })) === null || _b === void 0 ? void 0 : _b.args) === null || _c === void 0 ? void 0 : _c.storedLocation) ||
        fieldName;
    var defaultState = helpers_1.Helper.getNestedValue((_e = (_d = context === null || context === void 0 ? void 0 : context.state) === null || _d === void 0 ? void 0 : _d.dynamic) === null || _e === void 0 ? void 0 : _e[rootState || ''], ((_f = props === null || props === void 0 ? void 0 : props.tbody) === null || _f === void 0 ? void 0 : _f.storedLocation) || name);
    var memoizedThead = (0, react_2.useMemo)(function () { return thead; }, [thead]);
    var memoizedRows = (0, react_2.useMemo)(function () { return rows; }, [rows]);
    var memoizedLabels = (0, react_2.useMemo)(function () { return (labelsEndpoint ? labels : memoizedPropLabels); }, [labels, labelsEndpoint]);
    var memoizedSelectedCell = (0, react_2.useMemo)(function () { return selectedCell; }, [selectedCell]);
    var memoizedDefaultState = (0, react_2.useMemo)(function () { return defaultState; }, [defaultState]);
    (0, react_2.useEffect)(function () {
        if (memoizedLabels === null || memoizedLabels === void 0 ? void 0 : memoizedLabels.length) {
            addRows();
        }
    }, [memoizedLabels]);
    (0, react_2.useEffect)(function () {
        if (Array.isArray(memoizedDefaultState) &&
            (memoizedDefaultState === null || memoizedDefaultState === void 0 ? void 0 : memoizedDefaultState.length) > 0 &&
            JSON.stringify(memoizedDefaultState) !== JSON.stringify(rows)) {
            prepareRows(memoizedDefaultState);
        }
    }, [memoizedThead, memoizedLabels, memoizedDefaultState]);
    (0, react_2.useEffect)(function () {
        var handler = setTimeout(function () {
            props.onChange(JSON.parse(JSON.stringify(memoizedRows)));
            dispatch((0, sampleSlice_1.setStateValue)({
                path: "".concat(rootState, ".").concat(name, "_selectedCell"),
                value: memoizedSelectedCell,
            }));
        }, 300);
        return function () {
            clearTimeout(handler);
        };
    }, [memoizedRows, rootState, name, memoizedSelectedCell]);
    var prepareRows = function (state) {
        var list = addRows(false);
        list = list.map(function (row) {
            var matched = JSON.parse(JSON.stringify(state)).find(function (f) { return (f === null || f === void 0 ? void 0 : f.row_name) === (row === null || row === void 0 ? void 0 : row.row_name); }) || {};
            var saved = thead
                .filter(function (e) { return (e === null || e === void 0 ? void 0 : e.type) !== 'fixed'; })
                .map(function (e) { return e === null || e === void 0 ? void 0 : e.name; })
                .reduce(function (acc, curr) {
                acc[curr] = matched[curr];
                return acc;
            }, {});
            return __assign(__assign({}, row), saved);
        });
        setRows(JSON.parse(JSON.stringify(list)));
    };
    var handleFieldChange = function (row, rowIndex, field, value) {
        setRows(function (prevRows) {
            var _a;
            var updated = __spreadArray([], prevRows, true);
            updated[rowIndex] = __assign(__assign({}, updated[rowIndex]), (_a = {}, _a[field] = value, _a));
            return updated;
        });
        setSelectedCell({ row: row, value: value, field: field });
    };
    var addRows = function (modifyState) {
        if (modifyState === void 0) { modifyState = true; }
        var list = [];
        memoizedLabels.forEach(function (label, index) {
            var newRowId = "".concat(name, "_").concat(index + 1);
            list.push(createEmptyRow(newRowId, label));
        });
        if (modifyState) {
            setRows(list);
        }
        return list;
    };
    return ((0, jsx_runtime_1.jsxs)("table", { className: "w-full rounded-md add-more-table ".concat(props.disabled ? 'cursor-not-allowed' : '', " ").concat(props.className), style: { border: '5px' }, children: [(0, jsx_runtime_1.jsx)("thead", { className: "".concat(disabled || color === 'default' ? 'bg-[#EBECF8] text-[#000]' : 'bg-primary text-white', "  rounded-md"), children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { className: "p-2 text-left rounded-tl-md", style: { width: '10px', maxWidth: '10px', minWidth: '10px' }, children: "#" }), thead === null || thead === void 0 ? void 0 : thead.map(function (h, index) {
                            var _a;
                            return ((0, jsx_runtime_1.jsx)("th", { className: "p-2 text-left ".concat(props.disabled && index === ((_a = thead === null || thead === void 0 ? void 0 : thead.length) !== null && _a !== void 0 ? _a : 0) - 1 ? 'rounded-tr-md' : ''), style: { width: (h === null || h === void 0 ? void 0 : h.width) || '200px' }, children: h.label }, h.name));
                        })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: loading ? ((0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", { colSpan: thead.length + 1, className: 'w-full p-4', children: (0, jsx_runtime_1.jsx)(antd_1.Spin, { className: 'w-full' }) }) })) : (rows.map(function (row, rowIndex) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { className: "text-center text-gray-4 text-sm font-medium", style: { width: '10px', maxWidth: '10px', minWidth: '10px' }, children: rowIndex + 1 }), thead === null || thead === void 0 ? void 0 : thead.map(function (col) {
                            var _a, _b, _c, _d;
                            var key = row === null || row === void 0 ? void 0 : row.row_id;
                            var cellContent = null;
                            if ((col === null || col === void 0 ? void 0 : col.element) === 'input-text' ||
                                (col === null || col === void 0 ? void 0 : col.element) === 'input-number') {
                                cellContent = ((0, jsx_runtime_1.jsx)("form", { autoComplete: "off", children: (0, jsx_runtime_1.jsx)(antd_1.Input, { name: col === null || col === void 0 ? void 0 : col.name, value: (_a = row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) !== null && _a !== void 0 ? _a : '', placeholder: col === null || col === void 0 ? void 0 : col.placeholder, autoComplete: "off", disabled: disabled || (col === null || col === void 0 ? void 0 : col.disabled), onChange: function (e) {
                                            var val = e.target.value;
                                            if ((col === null || col === void 0 ? void 0 : col.element) === 'input-number') {
                                                var newValue = val.replace(/[^0-9.]/g, '');
                                                newValue = newValue.replace(/^0+(?=\d)/, '');
                                                newValue = newValue.replace(/(\..*?)\.+/g, '$1');
                                                val = newValue;
                                            }
                                            handleFieldChange(row, rowIndex, col === null || col === void 0 ? void 0 : col.name, val);
                                        } }, "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name)) }, "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name)));
                            }
                            else if ((col === null || col === void 0 ? void 0 : col.element) === 'circular-input') {
                                var value = (_b = row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) !== null && _b !== void 0 ? _b : 0;
                                var labelData = labels.find(function (e) { return (e === null || e === void 0 ? void 0 : e.value) === (row === null || row === void 0 ? void 0 : row.row_name); }) || {};
                                if ((labelData === null || labelData === void 0 ? void 0 : labelData.variant) === 'linear') {
                                    cellContent = ((0, jsx_runtime_1.jsx)(ACSlider_1.ACSlider, __assign({}, col, { name: "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name), value: value, containerClassName: "p-2 px-3", steps: labelData === null || labelData === void 0 ? void 0 : labelData.steps, min: labelData === null || labelData === void 0 ? void 0 : labelData.min, max: labelData === null || labelData === void 0 ? void 0 : labelData.max, onChange: function (e) {
                                            return handleFieldChange(row, rowIndex, col === null || col === void 0 ? void 0 : col.name, e);
                                        } })));
                                }
                                else {
                                    cellContent = ((0, jsx_runtime_1.jsx)(ACCircularInput_1.ACCircularInput, __assign({}, col, { name: "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name), value: value, max: (labelData === null || labelData === void 0 ? void 0 : labelData.max) || 360, onChange: function (e) {
                                            return handleFieldChange(row, rowIndex, col === null || col === void 0 ? void 0 : col.name, e);
                                        } })));
                                }
                            }
                            else if ((col === null || col === void 0 ? void 0 : col.element) === 'checkbox') {
                                cellContent = ((0, jsx_runtime_1.jsx)(antd_1.Checkbox, { checked: (_c = row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) !== null && _c !== void 0 ? _c : false, disabled: disabled || (col === null || col === void 0 ? void 0 : col.disabled), className: "w-full flex justify-center", onChange: function (e) {
                                        return handleFieldChange(row, rowIndex, col === null || col === void 0 ? void 0 : col.name, e.target.checked);
                                    } }, "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name)));
                            }
                            else if ((col === null || col === void 0 ? void 0 : col.element) === 'radio') {
                                cellContent = ((0, react_1.createElement)(ACRadioGroup_1.ACRadioGroup, __assign({}, col, { label: "", containerClassName: "p-2", name: "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name), key: "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name), value: (_d = row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) !== null && _d !== void 0 ? _d : null, onChange: function (e) {
                                        return handleFieldChange(row, rowIndex, col === null || col === void 0 ? void 0 : col.name, e);
                                    } })));
                            }
                            else if ((col === null || col === void 0 ? void 0 : col.element) === 'div') {
                                cellContent = ((0, jsx_runtime_1.jsx)("p", { className: "px-3 text-sm font-medium", children: row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name] }, "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name)));
                            }
                            return cellContent ? ((0, jsx_runtime_1.jsx)("td", { children: cellContent }, "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name))) : null;
                        })] }, row === null || row === void 0 ? void 0 : row.row_id)); })) })] }));
};
exports.ACFixedRowInputTable = ACFixedRowInputTable;
